import { z } from "zod";
import { normalizeUsStateCode } from "@common/states";

export const usStateCodeSchema = z
    .string()
    .transform((value, ctx) => {
        const normalized = normalizeUsStateCode(value);
        if (!normalized) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message:
                    'state must be a US state, given as a 2-letter code ("CA") or a full name ("California").',
            });
            return z.NEVER;
        }
        return normalized;
    })
    .describe(
        'US state, either a 2-letter code ("CA") or a full name ("California"), which is normalized to the code.',
    );
